export default __webpack_public_path__ + "static/media/home-decor-3.bd62a5fa.jpg";